/**
 * Simple function to generate uuid v4. Intended to use for setting key prop when
 * mapping an array of components, not for storing in a database
 */
export const generateUuid = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}
